<template>
	<div class="list-attendance">
		<div class="list-attendance-nav" style="margin: 20px 0">
			<el-button type="primary" style="padding: 8px 15px" @click="editWindow">新建班次</el-button>
		</div>
		<div class="list-attendance-form">
			<el-table :data="tableData" style="width: 100%">
				<el-table-column prop="desc" label="班级名称"></el-table-column>
				<el-table-column label="班次时间" width="200">
					<template slot-scope="scope">
						{{scope.row.startWorkTime + '-' +scope.row.endWorkTime}}
					</template>
				</el-table-column>
				<el-table-column label="所属门店">
					<template slot-scope="scope">
						{{storeFormat(scope.row.storeId)}}
					</template>
				</el-table-column>
				<el-table-column label="状态" width="100">
					<template slot-scope="scope">
						{{statusList[scope.row.status-1].label}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="150">
					<template slot-scope="scope">
						<div v-if="scope.row.status==1">
							<el-button type="text" size="small" @click="editWindow(scope.row)">编辑</el-button>
							<el-button type="text" size="small">失效</el-button>
						</div>
						<div v-if="scope.row.status==2">
							<span style="color:red">已失效</span>
							<el-button type="text" size="small">删除</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div>
			<el-dialog title="新建班次" :visible.sync="editShow" :close-on-click-modal="false" width="50%">
				<el-form label-position="left" label-width="80px">
					<el-form-item label="班次名称">
						<el-input v-model="form.desc"></el-input>
					</el-form-item>
					<el-form-item label="班次时间">
						<el-time-picker is-range v-model="form.time" format="HH:mm" value-format="HH:mm"
							range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
						</el-time-picker>
					</el-form-item>
					<el-form-item label="门店所属">
						<el-select v-model="form.storeId" @change="addStore">
							<el-option v-for="item in stores" :key="item.id" :label="item.title" :value="item">
							</el-option>
						</el-select>
						<el-tag :key="item.id" v-for="item in form.stores" closable style="margin-left:10px"
							@close="delStore(item)">
							{{item.title}}
						</el-tag>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="editShow = false">取 消</el-button>
					<el-button type="primary" @click="saveRoster">确 定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
				form: {
					id: "",
					desc: "",
					time: ['00:00', '23:59'],
					startWorkTime: "",
					endWorkTime: "",
					storeId: "",
					stores: [],
				},
				stores: [],
				editShow: false,
				statusList: [{
					label: "使用中",
					value: 1
				}, {
					label: "失效",
					value: 2
				}, {
					label: "删除",
					value: 3
				}, ]
			};
		},
		mounted() {
			this.getRoster();
			this.getStore();
		},
		computed: {
			storeFormat(id) {
				return (id) => {
					if (!id) return "暂无";
					let str = "";
					this.stores.forEach(s => {
						if (id.indexOf(s.id) >= 0) str ? str += ',' + s.title : str += s.title;
					})
					return str;
				}
			}
		},
		methods: {
			addStore() {
				let flag = false;
				let store = JSON.parse(JSON.stringify(this.form.storeId));
				this.form.stores.forEach(s => {
					if (s.id == store.id) flag = true;
				})
				this.form.storeId = ""
				if (flag) return this.$message.success("已选择")
				this.form.stores.push(store);
			},
			saveRoster() {
				if (!this.form.desc) return this.$message.success("请输入班次名称")
				if (!this.form.time.length) return this.$message.success("请选择班次时间")
				if (!this.form.stores.length) return this.$message.success("请选择门店")
				this.form.startWorkTime = this.form.time[0];
				this.form.endWorkTime = this.form.time[1];
				this.form.storeId = ""
				let arr = []
				this.form.stores.forEach(s => {
					arr.push(s.id)
				})
				let data = {
					id: this.form.id,
					startWorkTime: this.form.startWorkTime,
					endWorkTime: this.form.endWorkTime,
					desc: this.form.desc,
					storeIds: arr
				}
				if (data.id) {
					this.$http.post("dcheckuser/updateDRoster", JSON.stringify(data)).then(res => {
						if (res.body.code == 200) {
							this.editShow = false
							this.getRoster();
						} else {
							return this.$message.error(res.body.msg)
						}
					})
				} else {
					this.$http.post("dcheckuser/saveDRoster", JSON.stringify(data)).then(res => {
						if (res.body.code == 200) {
							this.editShow = false
							this.getRoster();
						} else {
							return this.$message.error(res.body.msg)
						}
					})
				}
			},
			editWindow(roster) {
				this.editShow = true;
				if (roster.id) {
					let stores = []
					this.stores.forEach(s => {
						if (roster.storeId.indexOf(s.id) >= 0) stores.push(s)
					})
					this.form = {
						id: roster.id,
						desc: roster.desc,
						time: [roster.startWorkTime, roster.endWorkTime],
						startWorkTime: "",
						endWorkTime: "",
						storeId: "",
						stores: stores,
					}
				} else {
					this.form = {
						id: "",
						desc: "",
						time: ['00:00', '23:59'],
						startWorkTime: "",
						endWorkTime: "",
						storeId: "",
						stores: [],
					}
				}
			},
			delStore(store) {
				this.form.stores.splice(this.form.stores.indexOf(store), 1)
			},
			getRoster() {
				this.$http.get("dcheckuser/allRoster").then(res => {
					this.tableData = res.body.data;
				})
			},
			getStore() {
				this.$http.get("store/list").then(res => {
					this.stores = res.body.data
				})
			},
		},
	};
</script>

<style>
	.list-attendance-form {
		margin-top: 40px;
	}

	.list-attendance-form .has-gutter th {
		text-align: center;
		line-height: 40px;
		background-color: #f4f1f4;
		font-size: 16px;
	}

	.list-attendance-form .el-table__row td {
		text-align: center;
		font-size: 16px;
		height: 80px;
	}

	.list-attendance-form .el-table__row td span {
		margin: 0 20px;
		font-size: 16px;
	}
</style>